// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2jveS","container__wrapper":"styles_container__wrapper__1uKPq","skeleton-animation":"styles_skeleton-animation__OAmVk"};